/**
 * 中文语言包
 */
export default {
  common: {
    confirm: "确认",
    cancel: "取消",
    save: "保存",
    delete: "删除",
    edit: "编辑",
    add: "新增",
    submit: "提交",
    search: "搜索",
    reset: "重置",

    back: "返回",
    enable: "启用",
    disable: "停用",
    logout: "退出登录",
    loading: "加载中...",
    noData: "暂无数据",
    success: "操作成功",
    failed: "失败",
    error: "操作失败",
    pleaseSelect: "请选择",
    pleaseInput: "请输入",
    language: "语言",
    yes: "是",
    no: "否",
    show: "显示",
    hide: "隐藏",
    refresh: "刷新",
    actions: "操作",
    status: "状态",
    createdAt: "创建时间",
    updatedAt: "更新时间",
    id: "ID",
    remark: "备注",
    sort: "排序",
    startTime: "开始时间",
    endTime: "结束时间",
    detail: "详情",
    view: "查看",
    close: "关闭",
    minutes: "分",
    createSuccess: "创建成功",
    updateSuccess: "更新成功",
  },
  device: {
    title: "设备",
    searchTitle: "设备查询",
    listTitle: "设备列表",
    loginLog: {
      searchTitle: "登录日志查询",
      listTitle: "登录日志列表",
    },

    fingerprint: "设备指纹",
    fingerprintHash: "设备指纹哈希",
    fingerprintPlaceholder: "请输入设备指纹",
    firstSeenUserId: "首次绑定用户",
    userIdPlaceholder: "用户ID",
    riskLevel: "风险等级",
    riskLevelPlaceholder: "请选择风险等级",
    inBlacklist: "黑名单",
    inBlacklistPlaceholder: "请选择黑名单状态",
    inBlacklistYes: "是",
    inBlacklistNo: "否",
    inBlacklistAll: "全部",
    deviceType: "设备类型",
    deviceTypePlaceholder: "选择设备类型",
    os: "操作系统",
    osPlaceholder: "操作系统名称",

    lastSeenAt: "最后活跃",
    startTime: "开始时间",
    endTime: "结束时间",
    sortBy: "排序字段",
    sortOrder: "排序",
    sortDesc: "降序",
    sortAsc: "升序",
    sort: {
      createdAt: "创建时间",
      lastSeen: "最后活跃",
      userCount: "关联用户数",
      riskScore: "风险分数",
    },

    updateRisk: "调整风险",
    addBlacklist: "加入黑名单",
    removeBlacklist: "移出黑名单",
    batchUpdateRisk: "批量调整风险",
    batchAddBlacklist: "批量拉黑",
    risk: {
      low: "低",
      medium: "中",
      high: "高",
      critical: "严重",
      blocked: "拦截",
      unknown: "未知",
    },
    reason: "原因",
    reasonPlaceholder: "请输入原因（10-500字）",
    reasonMin: "原因至少 {min} 个字符",

    loadFail: "加载失败",
    actionFail: "操作失败",
    blacklistAdded: "已加入黑名单",
    blacklistRemoved: "已移出黑名单",
    copy: "复制",
    copySuccess: "复制成功",
    copyFail: "复制失败",
    relatedUserCount: "关联用户数",
    riskScore: "风险分数",
    stats: {
      total: "设备总数",
      highRisk: "高风险设备",
      blacklisted: "黑名单设备",
      multiAccount: "多账号设备",
    },
    type: {
      desktop: "桌面端",
      mobile: "移动端",
      tablet: "平板",
    },
    basicInfo: "基础信息",
    features: "设备特征",
    osVersion: "系统版本",
    phoneModel: "机型",
    browser: "浏览器",
    browserVersion: "浏览器版本",
    browserEngine: "浏览器内核",
    language: "语言",
    timezone: "时区",
    platform: "平台",
    screenResolution: "屏幕分辨率",
    deviceMemory: "设备内存(GB)",
    hardwareConcurrency: "CPU线程数",
    colorDepth: "色深",
    pixelRatio: "像素比",
    touchSupport: "触摸支持",
    languages: "语言列表",
    riskAssessment: "风险评估",
    lastAssessedAt: "最近评估",
    ruleName: "规则",
    ruleDesc: "规则描述",
    score: "得分",
    triggeredAt: "触发时间",
    relatedUsers: "关联用户",
    relations: "关联信息",
    userId: "用户ID",
    relatedIps: "关联IP",
    loginLogs: "登录日志",
    loginStatusPlaceholder: "登录状态",
    loginTime: "登录时间",

    failureReason: "失败原因",
    ipAddress: "IP地址",
    userAgent: "User-Agent",
    operationLogs: "操作日志",
    operationTypePlaceholder: "操作类型",
    operationType: "操作类型",
    operationDesc: "操作描述",
    oldValue: "原值",
    newValue: "新值",
    operator: "操作人",
    back: "返回",
    reassess: "重新评估风险",
    reassessSuccess: "已重新评估",
    noData: "暂无数据",
    loginStatus: "登录状态",
    lastAssessed: "最近评估",
    riskConfig: "风险等级配置",

    saveSuccess: "保存成功",
    restrictions: "限制策略",
    restrictionsPlaceholder: "填写 JSON，默认沿用现有策略",
    scoreRange: "分数区间",
    color: "颜色",
    typeStats: "类型统计",
    operatorPlaceholder: "操作人ID",
    operation: {
      riskLevel: "风险等级调整",
      blacklistAdd: "加入黑名单",
      blacklistRemove: "移出黑名单",
      riskReassess: "重新评估",
    },
    riskRules: "风险规则",
    ruleList: "规则列表",
    ruleType: "规则类型",
    ruleTypeDevice: "设备",
    ruleTypeIp: "IP",
    ruleTypeBehavior: "行为",
    ruleCode: "规则编码",
    priority: "优先级",
    triggeredCount: "触发次数",
    parameters: "规则参数",
    parametersPlaceholder: "JSON 参数，留空表示不改",
    parametersInvalid: "参数必须是合法 JSON",
    editRule: "编辑规则",
    execute: "执行",
    executeConfirm: "确认执行此规则吗？",
    executeSuccess: "已触发执行",
    isEnabled: "启用",
    required: "必填",
    riskUpdated: "风险值已更新",
    viewDetail: "查看详情",
  },
  dateShortcuts: {
    today: "今天",
    last3d: "最近3天",
    last7d: "最近7天",
    thisMonth: "本月",
    last3m: "最近三个月",
    startTime: "开始时间",
    endTime: "结束时间",
  },
  login: {
    title: "LuckyTask 管理后台",
    username: "用户名",
    password: "密码",
    login: "登录",
    loginSuccess: "登录成功",
    loginFailed: "登录失败",
    usernameRequired: "请输入用户名",
    passwordRequired: "请输入密码",
    rememberMe: "记住我",
    verificationRequired: "请完成人机验证",
    verificationFailed: "人机验证失败",
    verificationExpired: "验证已过期，请重试",
  },
  menu: {
    dashboard: "仪表板",
    dashboard_index: "仪表板",
    user: "用户",
    user_management: "用户管理",
    user_list: "用户列表",
    user_tags: "用户标签",
    user_addresses: "用户地址",
    user_invitations: "邀请记录",
    task: "任务",
    task_management: "任务管理",
    task_list: "任务列表",
    task_detail: "任务详情",
    task_review: "任务审核",
    wallet: "钱包",
    wallet_management: "钱包管理",
    wallet_list: "钱包列表",
    wallet_ledger: "钱包流水",
    wallet_detail: "钱包详情",
    wallet_ledger_detail: "流水详情",
    wallet_recon_runs: "对账任务",
    wallet_recon_logs: "对账差异",
    device_management: "设备管理",
    device_list: "设备列表",
    device_risk_config: "风险等级配置",
    device_detail: "设备详情",
    device_login_log: "登录日志",
    device_risk_rules: "风险规则",
    lottery: "抽奖",
    lottery_management: "抽奖管理",
    lottery_list: "抽奖实例",
    lottery_plan_list: "抽奖计划",
    lottery_plan_detail: "计划详情",
    lottery_plan_create: "新建计划",
    lottery_plan_edit: "编辑计划",
    lottery_pending_draw: "待开奖",
    lottery_winner_list: "中奖用户",
    lottery_winner_detail: "中奖详情",
    lottery_participation: "参与记录",
    redemption: "兑换",
    redemption_management: "兑换管理",
    redemption_list: "订单列表",
    system: "系统管理",
    system_management: "系统管理",
    system_admin: "管理员管理",
    system_role: "角色管理",
    system_menu: "菜单管理",
    system_dept: "部门管理",
    system_post: "岗位管理",
    role: "角色管理",
    menu: "菜单管理",
    permission: "权限管理",
    task_assignment: "任务领取",
  },
  role: {
    title: "角色管理",

    code: "角色编码",
    codePlaceholder: "请输入角色编码",
    name: "角色名称",
    namePlaceholder: "请输入角色名称",

    remarkPlaceholder: "请输入备注",

    statusAll: "全部",
    statusEnable: "启用",
    statusDisable: "禁用",
    dataScope: "数据范围",
    dataScopePlaceholder: "请选择数据范围",
    dataScopeAll: "全部数据权限",
    dataScopeCustom: "自定义数据权限",
    dataScopeDept: "本部门数据权限",
    dataScopeDeptAndBelow: "本部门及以下数据权限",
    dataScopeSelf: "仅本人数据权限",
    dataScopeUnknown: "未知",

    menuPerm: "菜单权限",
    menuLoadFail: "加载菜单失败",
    menuPermFor: "编辑角色的菜单权限",
    collapseAll: "全部收起",
    expandAll: "全部展开",
    checkAll: "全部选择",
    uncheckAll: "全部取消",

    addTitle: "新增角色",
    editTitle: "编辑角色",

    loadFail: "加载角色数据失败",
    detailFail: "获取角色详情失败",
    submitFail: "提交失败，请重试",
    createSuccess: "创建成功",
    updateSuccess: "更新成功",
    deleteSuccess: "删除成功",
    deleteConfirmPrefix: "确认删除角色「",
    deleteConfirmSuffix: "」吗？",
    confirmTitle: "提示",
    parent: "上级角色",
    parentPlaceholder: "请选择上级角色",
    parentRoot: "顶级角色",
    dataPerm: "数据权限",
    dataPermFor: "编辑角色的数据权限",
    customDept: "自定义部门",
  },
  btn: {
    user: {
      ban: "封禁用户",
      unban: "解封用户",
      detail: "用户详情",
    },
    task: {
      create: "创建任务",
      edit: "编辑任务",
      delete: "删除任务",
      status: "修改状态",
      approve: "审核通过",
      reject: "审核拒绝",
    },
    wallet: {
      adjust: "余额调整",
      freeze: "冻结余额",
      unfreeze: "解冻余额",
      view: "查看钱包",
    },
    wallet_ledger: {
      export: "导出流水",
      view: "查看流水",
    },
    wallet_recon: {
      trigger: "发起对账",
      view: "查看对账",
      resolve: "处理差异",
    },
    lottery: {
      create: "创建抽奖",
      edit: "编辑抽奖",
      delete: "删除抽奖",
      draw: "开奖",
      cancel: "取消抽奖",
      view: "查看抽奖",
      planCreate: "新建抽奖计划",
      planUpdate: "编辑抽奖计划",
      planDelete: "删除抽奖计划",
      planStatus: "调整计划状态",
      planLogs: "查看计划日志",
      winnerReview: "中奖审核",
    },
    redemption: {
      ship: "发货",
      cancel: "取消订单",
      export: "导出订单",
    },
    system_admin: {
      add: "新增管理员",
      edit: "编辑管理员",
      delete: "删除管理员",
      reset_pwd: "重置密码",
    },
    system_role: {
      edit: "编辑角色",
      delete: "删除角色",
      assign: "分配权限",
    },
    system_menu: {
      add: "新增菜单",
      edit: "编辑菜单",
      delete: "删除菜单",
    },
    system_dept: {
      add: "新增部门",
      edit: "编辑部门",
      delete: "删除部门",
    },
  },
  wallet: {
    searchTitle: "钱包查询",
    listTitle: "钱包列表",
    userId: "用户ID",
    userIdPlaceholder: "请输入用户ID",
    nickname: "昵称",
    nicknamePlaceholder: "请输入昵称",
    phone: "手机号",
    phonePlaceholder: "请输入手机号",
    balanceRange: "余额区间",
    frozenRange: "冻结余额区间",
    totalEarnedRange: "累计获得区间",
    totalSpentRange: "累计消耗区间",
    min: "最小值",
    max: "最大值",
    registerRange: "注册时间",
    startTime: "开始时间",
    endTime: "结束时间",
    sortBy: "排序字段",
    sortOrder: "排序",
    sortDesc: "降序",
    sortAsc: "升序",
    sort: {
      balance: "余额",
      frozen: "冻结余额",
      totalEarned: "累计获得",
      totalSpent: "累计消耗",
      updatedAt: "更新时间",
    },
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    balance: "余额",
    frozenBalance: "冻结余额",
    availableBalance: "可用余额",
    totalEarned: "累计获得",
    totalSpent: "累计消耗",
    updatedAt: "更新时间",
    actions: "操作",
    viewDetail: "查看详情",
    viewLedger: "查看流水",
    adjust: "手动调整",
    adjustTitle: "手动调整余额",
    adjustType: "调整类型",
    adjustTypeAdd: "增加",
    adjustTypeDeduct: "扣减",
    amount: "金额",
    reason: "原因",
    remark: "备注",
    adjustReasonPlaceholder: "请输入调整原因，至少10个字符",
    remarkPlaceholder: "可填写备注",
    adjustPreview: "调整后预估余额：{value}",
    missingUserId: "缺少用户ID",
    adjustSuccess: "调整成功",
    adjustFail: "调整失败",
    freeze: "冻结",
    freezeTitle: "冻结金币",
    freezeReasonPlaceholder: "请输入冻结原因，至少10个字符",
    freezeHint: "可用余额：{balance}，冻结余额：{frozen}",
    freezeSuccess: "冻结成功",
    unfreeze: "解冻",
    unfreezeTitle: "解冻金币",
    unfreezeHint: "当前冻结：{frozen}",
    unfreezeSuccess: "解冻成功",
    actionFail: "操作失败",
    overview: "钱包概览",
    version: "版本号",
    registerTime: "注册时间",
    balanceTrend: "余额趋势（近30天）",
    date: "日期",
    transactionStats: "交易类型统计",
    incomeStats: "收入",
    expenseStats: "支出",
    type: "类型",
    count: "笔数",
    amountLabel: "金额",
    stats: {
      totalUsers: "钱包用户数",
      platformTotalBalance: "平台总余额",
      platformTotalFrozen: "平台总冻结",
      todayNewBalance: "今日新增余额",
    },
    loadFail: "加载失败",
  },
  walletLedger: {
    searchTitle: "流水查询",
    listTitle: "流水列表",
    userId: "用户ID",
    userIdPlaceholder: "请输入用户ID",
    nickname: "昵称",
    nicknamePlaceholder: "请输入昵称",
    timeRange: "时间范围",
    startTime: "开始时间",
    endTime: "结束时间",
    timeRequired: "请选择时间范围",
    transactionType: "交易类型",
    transactionMap: {
      task_reward: "任务奖励",
      invite_reward: "邀请奖励",
      lottery_entry: "抽奖参与",
      lottery_refund: "抽奖退款",
      manual_adjust: "人工调整",
      promo_bonus: "活动奖励",
      reconciliation: "对账调整",
      redeem_cost: "兑换消耗",
      unknown: "未知",
    },
    amount: "金额",
    amountRange: "金额范围",
    amountType: "金额方向",
    amountIncome: "收入",
    amountExpense: "支出",
    relatedEntity: "关联业务",
    relatedPlaceholder: "输入关联业务类型",
    idempotencyKey: "幂等键",
    idempotencyPlaceholder: "请输入幂等键",
    sortBy: "排序字段",
    sortOrder: "排序",
    sortDesc: "降序",
    sortAsc: "升序",
    sort: {
      createdAt: "交易时间",
      amount: "金额",
    },
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    export: "导出",
    checkExport: "查看导出状态",
    exportTitle: "创建导出任务",
    format: "导出格式",
    exportCreated: "导出任务已创建：{taskId}",
    exportFail: "导出失败",
    noTask: "暂无导出任务",
    exportReady: "导出已就绪，正在下载",
    exportStatus: "任务状态：{status}",
    loadFail: "加载失败",
    id: "流水ID",
    balanceAfter: "操作后余额",
    balanceBefore: "操作前余额",
    remark: "备注",
    createdAt: "交易时间",
    actions: "操作",
    viewDetail: "查看详情",
    detailTitle: "流水详情",
    invalidId: "流水ID无效",
    stats: {
      totalCount: "总笔数",
      totalIncome: "总收入",
      totalExpense: "总支出",
      netChange: "净变动",
    },
    max: "最大值",
    min: "最小值",
    related: "关联",
  },
  walletRecon: {
    runSearchTitle: "对账任务查询",
    runListTitle: "对账任务列表",
    status: "任务状态",
    source: "任务来源",
    sourceMap: {
      manual: "手动",
      cron: "定时",
      api: "API",
    },
    statusMap: {
      scheduled: "待执行",
      running: "执行中",
      completed: "完成",
      failed: "失败",
    },
    hasDiscrepancy: "是否存在差异",
    yes: "是",
    no: "否",
    startedRange: "开始时间范围",
    startTime: "开始时间",
    endTime: "结束时间",
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    runId: "任务ID",
    runIdPlaceholder: "请输入任务ID",
    range: "对账范围",
    discrepancyCount: "差异数量",
    duration: "耗时",
    startedAt: "开始时间",
    finishedAt: "结束时间",
    actions: "操作",
    viewDetail: "查看详情",
    trigger: "发起对账",
    triggerTitle: "手动触发对账",
    reconciliationType: "对账类型",
    type: {
      incremental: "增量对账",
      full: "全量对账",
    },
    rangeOptional: "自定义范围（可选）",
    triggerSuccess: "任务创建成功",
    triggerFail: "任务创建失败",
    loadFail: "加载失败",
    runDetailTitle: "任务详情",
    isIncremental: "是否增量",
    createdBy: "创建人",
    errorMessage: "错误信息",
    statistics: "统计信息",
    checkedUsers: "已检查用户数",
    totalDiff: "差异总额",
    resultSnapshot: "结果快照",
    noSnapshot: "暂无快照",
    viewLogs: "查看差异列表",
    logSearchTitle: "差异日志查询",
    logListTitle: "差异日志列表",
    logId: "日志ID",
    user: "用户",
    userId: "用户ID",
    userIdPlaceholder: "请输入用户ID",
    diff: "差异值",
    diffRange: "差异区间",
    min: "最小值",
    max: "最大值",
    detectedAt: "检测时间",
    resolutionNote: "处理备注",
    resolve: "处理",
    resolveTitle: "处理差异",
    action: "处理动作",
    actionResolved: "标记已解决",
    actionIgnored: "标记忽略",
    actionAdjust: "修正余额",
    note: "备注",
    notePlaceholder: "请输入处理备注，至少10个字符",
    resolveSuccess: "处理完成",
    resolveFail: "处理失败",
    statusLog: {
      unresolved: "未处理",
      resolved: "已解决",
      ignored: "已忽略",
    },
    walletBalance: "钱包余额",
    ledgerTotal: "流水合计",
    balance: "余额",
    invalidId: "无效ID",
  },
  lotteryPlan: {
    searchTitle: "抽奖计划查询",
    keyword: "关键词",
    keywordPlaceholder: "输入计划名称关键词",
    status: "计划状态",
    statusPlaceholder: "选择计划状态",
    triggerType: "触发类型",
    triggerTypePlaceholder: "选择触发方式",
    triggerTypeMap: {
      interval: "固定间隔",
      on_full: "满员触发",
      unknown: "未知",
    },
    createdRange: "创建时间",
    startTime: "开始时间",
    endTime: "结束时间",
    startTimePlaceholder: "请选择开始时间",
    endTimePlaceholder: "请选择结束时间",
    createdAt: "创建时间",
    sortBy: "排序字段",
    sortByPlaceholder: "选择排序字段",
    sortOrder: "排序",
    sortDesc: "降序",
    sortAsc: "升序",
    sort: {
      createdAt: "创建时间",
      startTime: "开始时间",
      endTime: "结束时间",
    },
    search: "查询",
    reset: "重置",
    create: "新建计划",
    createTitle: "新建抽奖计划",
    editTitle: "编辑抽奖计划",
    detailTitle: "计划详情",
    basicInfo: "基础信息",
    save: "保存",
    refresh: "刷新",
    planId: "计划ID",
    planName: "计划名称",
    planNamePlaceholder: "请输入计划名称",
    planDescription: "计划描述",
    planDescriptionPlaceholder: "请输入计划描述",
    coinPerEntry: "单次参与金币",
    targetEntries: "目标参与次数",
    countdownSeconds: "倒计时(秒)",
    maxEntriesPerUser: "单用户最多参与次数",
    createdCount: "已创建/上限",
    unlimited: "无限制",
    actions: "操作",
    viewDetail: "查看详情",
    edit: "编辑",
    activate: "激活",
    pause: "暂停",
    resume: "恢复",
    cancel: "取消",
    delete: "删除",
    deleteConfirm: "确认删除计划「{name}」吗？",
    confirmTitle: "提示",
    confirm: "确认",
    statusConfirm: "确认将计划「{name}」切换到「{status}」状态吗？",
    statusSuccess: "状态更新成功",
    statusFail: "状态更新失败",
    deleteSuccess: "删除成功",
    deleteFail: "删除失败",
    loadFail: "加载失败，请稍后重试",
    submitFail: "提交失败，请稍后重试",
    createSuccess: "创建成功",
    updateSuccess: "更新成功",
    editLocked: "当前状态不可修改",
    planNameRequired: "请输入计划名称",
    triggerTypeRequired: "请选择触发类型",
    intervalRequired: "请输入间隔分钟数",
    maxWaitRequired: "请输入最大等待秒数",
    minParticipationRequired: "请输入0-1之间的最低参与率",
    prizeSection: "奖品配置",
    prizeName: "奖品名称",
    prizeNamePlaceholder: "请输入奖品名称",
    prizeNameRequired: "请输入奖品名称",
    prizeType: "奖品类型",
    prizeTypeRequired: "请选择奖品类型",
    prizeTypeMap: {
      physical: "实物",
      voucher: "购物券",
      topup: "话费充值",
    },
    prizeCategory: "奖品类别",
    prizeCategoryPlaceholder: "请输入奖品类别",
    prizeCategoryRequired: "请输入奖品类别",
    prizeValueUsd: "奖品价值（USD）",
    prizeValueRequired: "请输入奖品价值",
    deliveryType: "发放方式",
    deliveryTypePlaceholder: "请输入发放方式（邮寄/虚拟）",
    deliveryTypeRequired: "请输入发放方式",
    estimatedDeliveryDays: "预计配送天数",
    estimatedDeliveryDaysPlaceholder: "请输入预计配送天数",
    estimatedDeliveryDaysRequired: "请输入预计配送天数",
    estimatedDeliveryDaysInvalid: "预计配送天数不能为负数",
    prizeImages: "奖品图片",
    prizeImagesPlaceholder: "输入图片URL后回车添加",
    prizeImagesRequired: "请至少添加一张奖品图片",
    prizeDescription: "奖品描述",
    prizeDescriptionPlaceholder: "请输入奖品描述",
    paramsSection: "抽奖参数",
    lifecycle: "生命周期",
    intervalMinutes: "间隔分钟数",
    maxWaitSeconds: "最大等待秒数",
    minParticipationRate: "最低参与率",
    allowPreCreate: "允许提前创建",
    preCreateCount: "提前创建数量",
    preCreateRequired: "请输入提前创建数量",
    maxLotteryCount: "最多创建次数",
    statusMap: {
      draft: "草稿",
      active: "激活",
      paused: "暂停",
      cancelled: "已取消",
      completed: "已完成",
      unknown: "未知",
    },
    startTimeRequired: "请选择开始时间",
    coinRequired: "请输入单次金币数",
    targetEntriesRequired: "请输入目标参与次数",
    countdownRequired: "倒计时需大于等于60秒",
    invalidId: "缺少计划ID",
    updatedAt: "更新时间",
    prizeTypeLabel: "奖品类型",
    prizeImageLabel: "奖品图片",
    viewImage: "查看图片",
    executionLogs: "执行日志",
    logStatusPlaceholder: "按执行状态筛选",
    logId: "日志ID",
    logLotteryId: "抽奖ID",
    logStatus: {
      label: "执行状态",
      success: "成功",
      failed: "失败",
      unknown: "未知",
    },
    logError: "错误信息",
    logCreatedAt: "执行时间",
    logLoadFail: "获取执行日志失败",
    createdRangePlaceholder: "选择创建时间",
    editSuccess: "编辑成功",
    listTitle: "抽奖计划列表",
    sortOrderPlaceholder: "选择排序方式",
  },
  lottery: {
    searchTitle: "抽奖查询",
    keyword: "关键词",
    keywordPlaceholder: "抽奖期号/奖品名称",
    planId: "计划ID",
    planIdPlaceholder: "请输入计划ID",
    status: "状态",
    statusPlaceholder: "选择状态",
    prizeType: "奖品类型",
    prizeTypePlaceholder: "选择奖品类型",
    prizeTypeMap: {
      physical: "实物",
      voucher: "购物券",
      topup: "话费充值",
    },
    startRange: "开始时间",
    drawRange: "开奖时间",
    drawStart: "开奖开始",
    drawEnd: "开奖结束",
    sortBy: "排序字段",
    sortOrder: "排序",
    sortDesc: "降序",
    sortAsc: "升序",
    sort: {
      createdAt: "创建时间",
      startTime: "开始时间",
      drawTime: "开奖时间",
    },
    search: "查询",
    reset: "重置",
    create: "新建抽奖",
    idPlaceholder: "输入抽奖ID精确查询",
    idInvalid: "请输入有效的抽奖ID",
    createTitle: "新建抽奖实例",
    viewDetail: "查看详情",
    refresh: "刷新",
    id: "抽奖ID",
    lotteryNumber: "抽奖期号",
    planName: "所属计划",
    prizeName: "奖品名称",
    prizeNamePlaceholder: "请输入奖品名称",
    prizeNameRequired: "请输入奖品名称",
    prizeValueCoins: "奖品金币价值",
    prizeValueRequired: "请输入奖品价值",
    prizeImage: "奖品图片",
    winnerEntryId: "中奖奖券ID",
    winnerUserId: "中奖用户ID",
    prizeImagePlaceholder: "请输入图片地址",
    prizeImageRequired: "请填写奖品图片地址",
    prizeDescription: "奖品描述",
    prizeDescriptionPlaceholder: "请输入奖品描述",
    coinPerEntry: "单次金币",
    coinRequired: "请输入单次金币",
    targetEntries: "目标参与次数",
    targetEntriesRequired: "请输入目标次数",
    countdownSeconds: "倒计时(秒)",
    countdownRequired: "倒计时需大于等于60秒",
    maxEntriesPerUser: "单用户上限",
    startTime: "开始时间",
    startTimePlaceholder: "请选择开始时间",
    endTime: "结束时间",
    endTimePlaceholder: "请选择结束时间",
    drawTime: "开奖时间",
    createdAt: "创建时间",
    updatedAt: "更新时间",
    statusMap: {
      upcoming: "未开始",
      active: "进行中",
      full: "已满员",
      drawn: "已开奖",
      cancelled: "已取消",
      unknown: "未知",
    },
    progress: "参与进度",
    actions: "操作",
    cancel: "取消抽奖",
    cancelSuccess: "取消成功",
    cancelFail: "取消失败",
    cancelReasonPlaceholder: "请输入取消原因，至少10个字符",
    cancelReasonMin: "取消原因不少于 {min} 个字符",
    confirm: "确认",
    cancelText: "取消",
    detailTitle: "抽奖详情",
    activeTickets: "当前票数",
    loadFail: "加载失败，请稍后重试",
    detailFail: "获取详情失败",
    createSuccess: "创建成功",
    createFail: "创建失败",
    autoDrawOnFull: "满员自动开奖",
    listTitle: "抽奖列表",
    prizeTypeRequired: "请选择奖品类型",
    startTimeRequired: "请选择开始时间",
  },
  lotteryWinner: {
    searchTitle: "中奖用户查询",
    listTitle: "中奖用户列表",
    lotteryId: "抽奖ID",
    lotteryIdPlaceholder: "请输入抽奖ID",
    userId: "用户ID",
    userIdPlaceholder: "请输入用户ID",
    claimStatus: "领奖状态",
    claimStatusMap: {
      pending_review: "待审核",
      pending_kyc: "待KYC",
      pending_shipment: "待发货",
      pending_grant: "待发放",
      shipped: "已发货",
      granted: "已发放",
      completed: "已完成",
      cancelled: "已取消",
      rejected: "已拒绝",
      unknown: "未知",
    },
    status: "领奖状态",
    riskLevel: "风险等级",
    risk: {
      low: "低",
      medium: "中",
      high: "高",
    },
    kycRequired: "需要KYC",
    kycStatus: "KYC状态",
    kycDone: "已完成",
    kycPending: "未完成",
    createdRange: "中奖时间",
    startTime: "开始时间",
    endTime: "结束时间",
    sortBy: "排序字段",
    sortOrder: "排序",
    sortDesc: "降序",
    sortAsc: "升序",
    sort: {
      createdAt: "创建时间",
    },
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    viewDetail: "查看详情",
    id: "中奖记录ID",
    lotteryNumber: "抽奖期号",
    prizeName: "奖品名称",
    prizeType: "奖品类型",
    prizeValueCoins: "奖品价值",
    createdAt: "中奖时间",
    updatedAt: "更新时间",
    loadFail: "加载失败，请稍后重试",
    detailFail: "获取详情失败",
    detailTitle: "中奖详情",
    actions: "操作",
    review: "审核",
    reviewTitle: "高风险审核",
    reviewResult: "审核结果",
    reviewApproved: "通过",
    reviewRejected: "拒绝",
    reviewNotes: "审核备注",
    reviewNotesPlaceholder: "请填写审核备注，至少10个字符",
    reviewSuccess: "审核完成",
    reviewFail: "审核失败",
    reviewLogs: "审核记录",
    logId: "日志ID",
    reviewType: "审核类型",
    reviewer: "审核人",
    reviewTime: "审核时间",
  },
  lotteryEntry: {
    searchTitle: "奖券记录查询",
    listTitle: "奖券记录列表",
    lotteryId: "抽奖ID",
    lotteryIdPlaceholder: "请输入抽奖ID",
    lotteryIdRequired: "请输入有效的抽奖ID",
    lotteryNumber: "抽奖期号",
    userId: "用户ID",
    userIdPlaceholder: "请输入用户ID",
    userIdRequired: "请输入有效的用户ID",
    ticketRange: "券段",
    ticketCount: "券数",
    coinsSpent: "消耗金币",
    status: "状态",
    statusMap: {
      active: "有效",
      refunded: "已退款",
      drawn: "已开奖",
      winner: "中奖",
      loser: "未中奖",
      expired: "已过期",
      unknown: "未知",
    },
    createdRange: "参与时间",
    startTime: "开始时间",
    endTime: "结束时间",
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    id: "记录ID",
    createdAt: "参与时间",
    loadFail: "加载失败，请稍后重试",
  },
  lotteryDraw: {
    searchTitle: "待开奖查询",
    listTitle: "待开奖列表",
    planId: "计划ID",
    planIdPlaceholder: "请输入计划ID",
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    manualDraw: "立即开奖",
    confirmTitle: "提示",
    confirm: "确认",
    cancel: "取消",
    confirmDraw: "确认对「{number}」执行手动开奖吗？",
    resultTitle: "开奖结果",
    winnerUser: "中奖用户ID",
    ticketIndex: "中奖券号",
    drawTime: "开奖时间",
    loadFail: "加载待开奖列表失败",
    drawSuccess: "手动开奖成功",
    drawFail: "手动开奖失败",
  },
  tabs: {
    refresh: "刷新",
    close: "关闭当前",
    closeOthers: "关闭其他",
    closeAll: "关闭所有",
  },
  permission: {
    noPermission: "暂无权限",
    accessDenied: "访问被拒绝",
  },
  dashboard: {
    welcome: "欢迎回来",
    subtitle: "祝您今天工作愉快",
    totalUsers: "总用户数",
    activeUsers: "活跃用户",
    pendingTasks: "待处理任务",
    revenue: "营业额",
    quickActions: "快速操作",
    addUser: "添加用户",
    createTask: "创建任务",
    viewReports: "查看报告",
    systemSettings: "系统设置",
    recentActivities: "最近活动",
  },
  iframe: {
    noSrc: "未配置 iframe 源地址",
  },
  dept: {
    title: "部门管理",

    addChild: "新增子部门",

    name: "部门名称",
    namePlaceholder: "请输入部门名称",
    code: "部门编码",
    codePlaceholder: "请输入唯一编码",
    codeExists: "部门编码已存在，请更换编码",
    leader: "负责人",
    leaderPlaceholder: "请输入负责人",
    phone: "联系电话",
    phonePlaceholder: "请输入联系电话",
    email: "邮箱",
    emailPlaceholder: "请输入邮箱",

    statusAll: "全部",
    statusEnable: "启用",
    statusDisable: "禁用",

    addTitle: "新增部门",
    editTitle: "编辑部门",
    parent: "上级部门",
    parentPlaceholder: "请选择上级部门",
    type: "部门类型",
    typePlaceholder: "请选择类型",
    typeCompany: "公司",
    typeDepartment: "部门",
    typeGroup: "小组",

    loadFail: "加载部门数据失败",
    detailFail: "获取部门详情失败",
    submitFail: "提交失败，请重试",
    createSuccess: "创建成功",
    updateSuccess: "更新成功",
    deleteSuccess: "删除成功",
    deleteConfirmPrefix: "确认删除部门「",
    deleteConfirmSuffix: "」吗？",
    confirmTitle: "提示",
  },
  post: {
    title: "岗位管理",

    addChild: "新增子岗位",

    code: "岗位编码",
    codePlaceholder: "请输入岗位编码",
    name: "岗位名称",
    namePlaceholder: "请输入岗位名称",

    remarkPlaceholder: "请输入备注",

    statusAll: "全部",
    statusEnable: "启用",
    statusDisable: "禁用",

    addTitle: "新增岗位",
    editTitle: "编辑岗位",

    loadFail: "加载岗位数据失败",
    detailFail: "获取岗位详情失败",
    submitFail: "提交失败，请重试",
    createSuccess: "创建成功",
    updateSuccess: "更新成功",
    deleteSuccess: "删除成功",
    deleteConfirmPrefix: "确认删除岗位「",
    deleteConfirmSuffix: "」吗？",
    confirmTitle: "提示",
    listTitle: "岗位列表",
  },
  adminUser: {
    title: "管理员管理",
    add: "新增管理员",
    refresh: "刷新",
    search: "查询",
    reset: "重置",
    id: "ID",
    username: "用户名",
    usernamePlaceholder: "请输入用户名",
    realName: "真实姓名",
    realNamePlaceholder: "请输入真实姓名",
    status: "状态",
    statusPlaceholder: "请选择状态",
    statusEnable: "启用",
    statusDisable: "禁用",
    statusLocked: "已锁定",
    statusAll: "全部",
    sex: "性别",
    sexPlaceholder: "请选择性别",
    sexUnknown: "未知",
    sexMale: "男",
    sexFemale: "女",
    dept: "所属部门",
    deptPlaceholder: "请选择部门",
    role: "主要角色",
    rolePlaceholder: "请选择角色",
    mobile: "手机号码",
    mobilePlaceholder: "请输入手机号码",
    email: "邮箱",
    emailPlaceholder: "请输入邮箱",
    telegram: "Telegram",
    telegramPlaceholder: "请输入 Telegram 账号",
    remark: "备注",
    remarkPlaceholder: "请输入备注",
    password: "登录密码",
    newPassword: "新密码",
    passwordPlaceholder: "请输入密码",
    resetPassword: "重置密码",
    lastLoginAt: "最后登录时间",
    enable: "启用",
    disable: "禁用",
    delete: "删除",
    edit: "编辑",
    actions: "操作",
    addTitle: "新增管理员",
    editTitle: "编辑管理员",
    confirm: "确定",
    cancel: "取消",
    loadFail: "加载管理员列表失败",
    detailFail: "获取管理员详情失败",
    submitFail: "提交失败，请重试",
    createSuccess: "创建成功",
    updateSuccess: "更新成功",
    deleteSuccess: "删除成功",
    deleteConfirmPrefix: "确认删除管理员「",
    deleteConfirmSuffix: "」吗？",
    confirmTitle: "提示",
    listTitle: "管理员列表",
  },
  user: {
    title: "用户管理",
    id: "ID",
    userId: "用户ID",
    userIdPlaceholder: "请输入用户ID",
    phone: "手机号",
    phonePlaceholder: "请输入手机号",
    nickname: "昵称",
    nicknamePlaceholder: "请输入昵称",
    referralCode: "邀请码",
    referralCodePlaceholder: "请输入邀请码",
    ipAddress: "注册IP",
    ipPlaceholder: "请输入注册IP",
    lastLoginIp: "最后登录IP",
    registerRegion: "注册地区",
    lastLoginRegion: "登录地区",
    tagPlaceholder: "请选择标签",

    statusPlaceholder: "请选择状态",
    statusActive: "正常",
    statusBanned: "已封禁",
    statusPending: "待完成KYC",
    statusSuspended: "已冻结",
    statusAll: "全部",
    riskLevel: "风险等级",
    riskLevelPlaceholder: "请选择风险等级",
    riskLow: "低",
    riskMedium: "中",
    riskHigh: "高",
    riskBlocked: "黑名单",
    preferredLanguage: "首选语言",
    timezone: "时区",
    email: "邮箱",
    authProviders: "认证绑定",
    provider: "提供方",
    providerUserId: "第三方用户ID",
    linkedAt: "绑定时间",
    deviceInfo: "设备信息",
    fingerprint: "设备指纹",
    lastSeen: "最后出现时间",
    deviceRisk: "设备风险",
    firstSeenUserId: "首次出现用户",
    deviceMeta: "设备详情",
    userAgent: "User Agent",
    deviceModel: "设备型号",
    osVersion: "系统版本",
    browserVersion: "浏览器",
    inviter: "邀请人",
    invitedBy: "邀请人",
    deviceRiskLevel: "风险等级",
    empty: "暂无数据",
    registerRange: "注册时间",
    startTime: "开始时间",
    endTime: "结束时间",
    sortBy: "排序字段",
    sortOrder: "排序方式",
    sortCreated: "创建时间",
    sortStart: "上线时间",
    sortParticipants: "参与人数",
    sortReward: "奖励金额",
    sortRegister: "注册时间",
    sortLogin: "最后登录时间",
    sortWallet: "钱包余额",
    sortInvite: "邀请人数",
    sortAsc: "升序",
    sortDesc: "降序",
    walletBalance: "钱包余额",
    walletFrozen: "冻结余额",
    walletTotalEarned: "累计获得",
    walletTotalSpent: "累计消耗",
    invitationCount: "邀请人数",
    tags: "标签",
    registerTime: "注册时间",
    lastLoginTime: "最后登录时间",

    export: "导出",
    exportCsv: "导出 CSV",
    exportExcel: "导出 Excel",
    exportSuccess: "导出任务已提交",

    changeStatus: "修改状态",
    batchStatus: "批量修改状态",
    batchTags: "批量添加标签",

    reason: "原因",
    reasonPlaceholder: "请输入操作原因（不少于10字）",
    reasonMin: "原因至少10个字符",
    notes: "备注",
    addNote: "新增备注",
    notePlaceholder: "请输入备注（不少于10字）",
    noteEmpty: "暂无备注",
    copySuccess: "复制成功",
    copyFail: "复制失败",
    updateSuccess: "更新成功",
    loadFail: "加载用户失败",
    submitFail: "提交失败，请重试",

    tasks: "任务领取",
    walletLedger: "钱包流水",
    lotteryEntries: "抽奖券记录",
    delete: "删除",
    detail: "详情",
    ipAddressPlaceholder: "请输入IP地址",
    reset: "重置",
    search: "搜索",
    status: "状态",
  },
  userTags: {
    title: "用户标签管理",
    id: "ID",
    name: "标签名称",
    color: "标签颜色",
    isSystem: "是否系统标签",
    system: "系统",
    custom: "自定义",
    actions: "操作",
    create: "新增标签",
    edit: "编辑",
    delete: "删除",
    createTitle: "新增标签",
    editTitle: "编辑标签",
    namePlaceholder: "请输入标签名称",
    colorPlaceholder: "请选择颜色",
    nameMin: "名称过短",
    loadFail: "加载标签失败",
    submitFail: "提交失败",
    createSuccess: "创建成功",
    updateSuccess: "更新成功",
    deleteSuccess: "删除成功",
    deleteConfirm: "确认删除该标签？",
    confirmTitle: "提示",
    confirm: "确定",
    cancel: "取消",
  },
  userAddress: {
    title: "用户地址",
    userId: "用户ID",
    userIdPlaceholder: "请输入用户ID",
    search: "查询",
    reset: "重置",
    id: "ID",
    recipientName: "收件人",
    recipientPhone: "联系电话",
    address: "收货地址",
    isDefault: "默认地址",
    default: "默认",
    normal: "普通",
    createdAt: "创建时间",
    loadFail: "加载地址失败",
  },
  userInvite: {
    title: "邀请关系",
    userId: "用户ID",
    userIdPlaceholder: "请输入用户ID",
    status: "奖励状态",
    statusPlaceholder: "请选择状态",
    statusPending: "待发放",
    statusGranted: "已发放",
    statusFailed: "发放失败",
    inviteRange: "邀请时间",
    rewardRange: "奖励发放时间",
    startTime: "开始时间",
    endTime: "结束时间",
    invitedUserFilter: "被邀请用户",
    invitedUserFilterPlaceholder: "请输入被邀请用户ID",
    invitationId: "邀请ID",
    invitationIdPlaceholder: "请输入邀请ID",
    inviterUserId: "邀请人用户ID",
    inviteeUserId: "受邀人用户ID",
    inviteCode: "邀请码",
    inviteCodePlaceholder: "请输入邀请码",
    createdRange: "创建时间",
    completedRange: "完成时间",
    createdAt: "创建时间",
    completedAt: "完成时间",
    sortBy: "排序字段",
    sortOrder: "排序方式",
    sortCreated: "按创建时间",
    sortCompleted: "按完成时间",
    sortTasks: "按完成任务",
    sortAsc: "升序",
    sortDesc: "降序",
    statusCompleted: "已完成",
    statusExpired: "已过期",
    statusCancelled: "已取消",
    tasksCompletedPlaceholder: "请输入完成任务数",
    search: "查询",
    reset: "重置",
    inviter: "邀请人",
    invitedUsers: "被邀请用户",
    rewards: "奖励记录",
    totalInvited: "总邀请人数",
    totalRewards: "总奖励次数",
    totalCoins: "总奖励金额",
    nickname: "昵称",
    registerTime: "注册时间",
    completedTask: "完成任务数",
    tasksCompleted: "完成任务数",
    rewardStatus: "奖励状态",
    rewardId: "奖励ID",
    invitedUserId: "被邀请用户ID",
    invitedUserName: "被邀请用户昵称",
    rewardCoins: "奖励金额",
    awardedAt: "发放时间",
    loadFail: "加载邀请关系失败",
    inviteeUserIdPlaceholder: "请输入受邀人ID",
    inviterUserIdPlaceholder: "请输入邀请人ID",
    listTitle: "邀请列表",
  },

  task: {
    pageTitle: "任务管理",
    searchTitle: "任务查询",
    tabBasic: "基本信息",
    tabDescription: "任务描述",
    tabSteps: "任务步骤",
    tabProof: "凭证要求",
    tabQuota: "奖励与配额",
    tabTime: "时间配置",
    tabPreview: "预览",
    detailTab: "详情",
    previewTab: "预览",
    previewTitle: "任务预览",
    id: "任务ID",
    idPlaceholder: "请输入任务ID",
    title: "标题",
    titlePlaceholder: "请输入标题",
    category: "分类",
    categoryPlaceholder: "请选择分类",
    taskType: "任务类型",
    taskTypePlaceholder: "请选择任务类型",
    type: {
      watch_ad: "看广告",
      interaction: "互动",
      app_download: "应用下载",
      invite: "邀请",
      check_in: "签到",
    },
    status: "状态",
    statusPlaceholder: "请选择状态",
    statusMap: {
      draft: "草稿",
      pending_review: "待审核",
      active: "进行中",
      paused: "已暂停",
      closed: "已关闭",
      unknown: "未知",
    },
    sponsorType: "来源",
    sponsorPlaceholder: "请选择来源",
    sponsorName: "品牌名称",
    system: "系统",
    brand: "品牌",
    createdAt: "创建时间",
    startTime: "上线时间",
    endTime: "下线时间",
    autoExpireMinutes: "自动过期(分钟)",
    maxDailyCompletions: "每日上限",
    quotaTotal: "总配额",
    startEndRange: "上线时间段",
    rewardCoins: "奖励(金币)",
    verificationMode: "验证方式",
    verificationAuto: "自动",
    verificationManual: "人工",
    verificationCallback: "回调",
    quota: "配额",
    unlimited: "不限",
    participants: "参与人数",
    createdBy: "创建人",
    actions: "操作",
    search: "查询",
    reset: "重置",
    refresh: "刷新",
    sortBy: "排序字段",
    sortOrder: "排序方式",
    sortCreated: "创建时间",
    sortStart: "上线时间",
    sortParticipants: "参与人数",
    sortReward: "奖励金额",
    sortAsc: "升序",
    sortDesc: "降序",
    create: "新建任务",
    batchPublish: "批量发布",
    batchPause: "批量暂停",
    batchDelete: "批量删除",
    view: "查看",
    edit: "编辑",
    copy: "复制",
    delete: "删除",
    publish: "发布",
    pause: "暂停",
    resume: "恢复",
    viewDetail: "任务详情",
    description: "任务描述",
    featurePending: "功能开发中",
    deleteConfirm: "确认删除所选任务吗？",
    deleteSuccess: "删除成功",
    loadFail: "任务加载失败",
    actionFail: "操作失败，请重试",
    copySuccess: "复制成功",
    statusUpdated: "状态已更新",
    batchPublishReason: "批量发布",
    batchPauseReason: "批量暂停",
    detailTitle: "任务详情",
    proof: "凭证要求",
    proofLabel: "字段",
    proofField: "字段键名",
    proofType: "类型",
    required: "必填",
    requiredShort: "必填",
    hint: "提示",
    addProof: "新增凭证项",
    moveUp: "上移",
    moveDown: "下移",
    uploadSuccess: "图片上传成功",
    uploadFail: "图片上传失败",
    meta: "元数据",
    metaDifficulty: "难度",
    metaDuration: "预估时长",
    metaReward: "预估奖励",
    metaTags: "标签",
    steps: "步骤",
    createSuccess: "创建成功",
    updateSuccess: "更新成功",
    unsavedConfirm: "当前有未保存的修改，确认关闭吗？",
    htmlSource: "HTML源码",
    stats: {
      total: "任务总数",
      active: "进行中",
      draft: "草稿",
      today: "今日新增",
    },
    listTitle: "任务列表",
    maxAttempts: "最大尝试次数",
    updatedAt: "更新时间",
  },
  taskReview: {
    title: "任务提交审核",
    searchTitle: "提交筛选",
    submissionId: "提交ID",
    submissionIdPlaceholder: "请输入提交ID",
    taskId: "任务ID",
    taskIdPlaceholder: "请输入任务ID",
    search: "查询",
    reset: "重置",
    userId: "用户ID",
    userIdPlaceholder: "请输入用户ID",
    reviewResult: "审核结果",
    reviewResultPlaceholder: "请选择审核结果",
    submittedRange: "提交时间",
    reviewedRange: "审核时间",
    history: "提交历史",
    reviewClaimedAt: "领取审核时间",
    assignmentInfo: "任务进度信息",
    claimedAt: "领取时间",
    expiresAt: "过期时间",
    attemptCount: "提交次数",
    autoVerifyAt: "自动验证时间",
    rewardLedgerId: "奖励流水ID",
    rejectionReason: "拒绝原因",
    riskInfo: "风控信息",
    ipAddress: "IP地址",
    deviceFingerprint: "设备指纹",
    notes: "备注",
    reviewer: "审核人",
    requirement: "任务要求",
    userSubmission: "用户提交",
    requirementExample: "任务要求示例",
    userSubmissionProof: "用户提交凭证",
    clickToCompare: "点击对比",
    noSubmission: "未提交",
    expiresInDays: "剩余 {days} 天",
    expiresInHours: "剩余 {hours} 小时",
    expiresInMinutes: "剩余 {minutes} 分钟",
    expired: "已过期",
    verificationMode: "验证方式",
    verificationModeMap: {
      auto: "自动",
      manual: "人工",
      callback: "回调",
    },
    reviewResultMap: {
      pending: "待审核",
      approved: "已通过",
      rejected: "已拒绝",
    },
    stats: {
      total: "总提交",
      pending: "待审核",
      approved: "已通过",
      rejected: "已拒绝",
    },
    status: {
      unclaimed: "未领取",
      mine: "我的审核",
      claimed: "已领取",
      finished: "已结束",
    },
    passRate: "通过率",
    actions: "操作",
    view: "查看",
    reviewComment: "审核备注",
    reviewCommentPlaceholder: "请输入审核备注（选填）",
    detailTitle: "提交详情",
    basicInfo: "基本信息",
    proofCompare: "凭证对比",
    submission: "提交凭证",
    value: "值",
    takeReview: "领取审核",
    takeBtn: "领取任务",
    takeSuccess: "领取成功",
    claimNote: "当前无人审核，可点击领取该提交",
    claimedByOther: "已被 {name} 领取，等待审核",
    reviewAction: "审核",
    isFinal: "终审",
    reviewSubmit: "提交审核",
    saveDraft: "保存草稿",
    draftSaved: "草稿已保存（本地）",
    quickTitle: "快捷标签",
    quick: {
      blur: "图片模糊",
      mismatch: "与要求不符",
      missing: "凭证缺失",
      repeat: "重复提交",
    },
    taskTitle: "任务标题",
    taskIntro: "任务介绍",
    taskSteps: "任务步骤",
    taskContext: "任务上下文",
    proofRequirements: "凭证要求",
    submissionProofs: "提交凭证",
    requirementHidden: "已收起凭证要求",
    showReq: "展开凭证要求",
    hideReq: "收起凭证要求",
    expandIntro: "展开",
    collapseIntro: "收起",
    user: "用户",
    proof: "凭证要求",
    reviewInfo: "审核信息",
    reviewedBy: "审核人",
    reviewedAt: "审核时间",
    submittedAt: "提交时间",
    approveConfirm: "确认通过该提交？",
    rejectConfirm: "请输入拒绝原因（可选）",
    reviewSuccess: "审核提交成功",
    batchApprove: "批量通过",
    batchReject: "批量拒绝",
    selectWarning: "请先选择至少一条记录",
    loadFail: "提交记录加载失败",
    detailFail: "提交详情加载失败",
  },
  taskAssignment: {
    searchTitle: "任务领取",
    assignmentId: "领取ID",
    assignmentIdPlaceholder: "请输入领取ID",
    taskId: "任务ID",
    taskIdPlaceholder: "请输入任务ID",
    userId: "用户ID",
    userIdPlaceholder: "请输入用户ID",
    status: "状态",
    statusPlaceholder: "请选择状态",
    reviewerId: "审核人",
    reviewerIdPlaceholder: "请输入审核人ID",
    myReview: "我的审核",
    claimedRange: "领取时间",
    submittedRange: "提交时间",
    statusMap: {
      submitted: "已提交",
      in_progress: "进行中",
      approved: "已通过",
      rejected: "已拒绝",
      expired: "已过期",
      cancelled: "已取消",
      unknown: "未知",
    },
    claimedAt: "领取时间",
    submittedAt: "提交时间",
    reviewedAt: "审核时间",
    attemptCount: "提交次数",
    listTitle: "任务领取列表",
  },
  tasks: {
    taskDetail: "任务详情",
    description: "任务介绍",
    steps: "完成步骤",
    submissionRequirements: "提交要求",
    claimTask: "领取任务",
    types: {
      video: "看视频",
      app_download: "下载应用",
      social: "社交互动",
      referral: "邀请好友",
      checkin: "每日签到",
    },
    difficulty: {
      easy: "简单",
      medium: "中等",
      hard: "困难",
    },
  },
};
